
export default {
  name: 'modal-facteur-ponderation',
  components: {},
  props: [],
  data () {
    return {
      filter: null,
      fields: [ 'designation', { 'key': 'oui', 'label': '' }, {'key':'ponderation','label':'Facteur de pondération'}, 'referer',],
      facteurs:[{
        designation:'FACTEUR DE PONDERATION',
        oui:'',
        ponderation: 2,
        conferer:'Ordino. 5'
      }],
      perPage: 10,
      currentPage: 1,
      state:null,
      loading: false,

      poderation_is_loading: true

    }
  },
  watch: {
    facteursPonderations() {
        this.facteurs = this.facteursPonderations
    }
  },
  computed: {
    facteursPonderations(){
      return this.$store.getters["facteursPonderations"];
    },
    consultationEnCours() {
      return this.$store.getters['consultationPatientEnCours']
    },

  },
  mounted () {
    this.$store.dispatch('getFacteursPonderations',{id:this.consultationEnCours.id,enCours:true}).then(() =>  {
      this.poderation_is_loading = false
    })
  },
  methods: {

    onChangePondeartion(index, value) {
      console.log("ON CHANGE", index, " -- ",value)
      this.facteurs[index].selected = value
    },

    updateFacteurs: function(){
      this.loading = true
      this.$store.dispatch('updateFacteursPonderations',{id:this.consultationEnCours.id,facteurs:this.facteurs}).then(
        () =>{
          this.loading = false
          this.$store.dispatch('getFacteursPonderations',{id:this.consultationEnCours.id,enCours:true});
          this.doSuccess()
          this.$refs['fac-ponderation-modal'].click();
          
        }
      )
    },

    doSuccess: function(){
        this.$toasted.show('Les facteurs de pondération ont été mis à jour',{
          duration: 3000,
          action:[
          {
          text:'X',
          onClick:(e,toastObject)=>{
            toastObject.goAway(0);
          }
          }
        ],
        theme:'toasted-primary',
        type:'success',
        position:'top-center'
    
      })
    }

  }
}


